import { RouterProvider } from 'react-router-dom';
import { router } from './config';

const AppRouter = (): JSX.Element => <RouterProvider router={router} />;

export default AppRouter;
